import { AutoMap } from '@automapper/classes';

export class ProcessSamplingConditionEntity {
    Id?: number;
    @AutoMap()
    Apr!: number;
    @AutoMap()
    Temoin!: string;
    @AutoMap()
    Hygrometrie1!: number;
    @AutoMap()
    Hygrometrie2!: number;
    @AutoMap()
    Hygrometrie3!: number;
    @AutoMap()
    VitesseVent1!: number;
    @AutoMap()
    VitesseVent2!: number;
    @AutoMap()
    VitesseVent3!: number;
    @AutoMap()
    Meteo!: number;
    @AutoMap()
    ExpositionClimatique!: number;
}
